import config from "../config/config";

export function imageByIndex(id) {
  return id ? `${config.api_image}/${id}` : null;
}